import { render, staticRenderFns } from "./RefundView.vue?vue&type=template&id=3bd5fc8b&scoped=true&"
import script from "./RefundView.vue?vue&type=script&lang=js&"
export * from "./RefundView.vue?vue&type=script&lang=js&"
import style0 from "./RefundView.vue?vue&type=style&index=0&id=3bd5fc8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5fc8b",
  null
  
)

export default component.exports